import { apiService } from "@/common/api.service.js";

export default {
  // Division plans list
  getAllDivisionPlans() {
    const endpoint = `/api/division-plan-all/`;
    return apiService(endpoint);
  },

  // Division plan details
  divisionPlanData(planId) {
    const endpoint = `/api/division-plans/${planId}/`;
    return apiService(endpoint);
  },

  // Create division plan
  divisionPlanCreate(payload) {
    const endpoint = `/api/division-plan-create/`;
    return apiService(endpoint, "POST", payload);
  },

  // Update division plan
  divisionPlanUpdate(payload) {
    const endpoint = `/api/division-plan-update/${payload.id}/`;
    return apiService(endpoint, "PATCH", payload);
  },

  // Publish division plan (assumed endpoint)
  divisionPlanPublish(payload) {
    const endpoint = `/api/division-plan-publish/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  // Division site plans
  divisionSitePlans(payload) {
    const endpoint = `/api/attach-site-plans/division/${payload.id}/${payload.company}/`;
    return apiService(endpoint);
  },

  // Create division site plan relation
  createDivisionSitePlanRelation(payload) {
    const endpoint = `/api/division-site-plan-create/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  // Carbon tracker
  divisionPlanCarbonTracker(payload) {
    const endpoint = `/api/division-plan-carbon-tracker/${payload.id}/`;
    return apiService(endpoint);
  },

  divisionPlanCarbonTrackerUpdate(payload) {
    const endpoint = `/api/division-plan-carbon-tracker/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },
};
